import DescriptionView from "components/DescriptionView";
import DocumentViewerModal from "components/DocumentViewer";
import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import { FC, useEffect, useState } from "react";
import { editInvestigation } from "services/incidentService";
import { FILE_URL, Investigation, Roles } from "types";
import { LoadingIcon } from "utils/constant";
import { errorHandler, errorHandlerOnForm, hasRole } from "utils/helper";

type Props = {
  investigation: Investigation;
  setRefetch: React.Dispatch<React.SetStateAction<boolean>>;
  setChangeTab: React.Dispatch<React.SetStateAction<string>>;
};

const InvestigationNarration: FC<Props> = ({
  investigation,
  setRefetch,
  setChangeTab,
}) => {
  const { loginData } = useAuth();
  const { showTooltip } = useTooltip();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<string>("");
  const isProsecutor = hasRole(loginData?.roles, [Roles.prosecutor]);

  useEffect(() => {
    setResult(investigation?.investigation_result_naration || "");
  }, [investigation]);

  return (
    <div>
      <div>
        {/* <div>
          <DescriptionView
            label={"Investigation Result Narration"}
            value={
              investigation?.investigation_result_naration ||
              "No narration available"
            }
          />
        </div> */}

        <DocumentViewerModal
          documents={investigation?.documents || []}
          baseUrl={`${process.env.REACT_APP_API_BASE_URL}${FILE_URL.RECEIVING_INVESTIGATION}`}
          layout="list"
          hide={false}
          label=""
          hideEmptyFile={true}
        />

        {isProsecutor && !investigation?.end_date && (
          <div>
            <textarea
              placeholder="Type your remark here ..."
              className="bg-[#F8F8F8] rounded-md py-2 px-3 w-full focus:outline-none focus:ring focus:ring-blue-300"
              name="comment"
              value={result}
              rows={4}
              onChange={(e) => setResult(e.target.value)}
            />
            <div className="flex justify-end mt-2">
              <button
                type="submit"
                className={`border border-[#212121] bg-[#212121] px-10 py-2 text-white 
              font-[Poppins] cursor-pointer font-[500] 
              text-base rounded-md hover:bg-[#414040]
              ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                disabled={loading || !result}
                onClick={() => {
                  setLoading(true);
                  editInvestigation({
                    ...investigation,
                    investigation_result_naration: result,
                  })
                    .then(() => {
                      setRefetch((prev) => !prev);
                      setLoading(false);
                      setResult("");
                      showTooltip("Successfully Submitted!", "success");
                      setChangeTab("Investigation");
                    })
                    .catch((error) => {
                      setLoading(false);
                      showTooltip(
                        error?.response?.data?.detail ||
                          errorHandlerOnForm(error) ||
                          errorHandler(error) ||
                          "Something went wrong. Please try again.",
                        "error"
                      );
                    });
                }}
              >
                {loading ? (
                  <div className="flex items-center justify-center">
                    {LoadingIcon}
                    Loading...
                  </div>
                ) : (
                  "Update"
                )}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InvestigationNarration;
